import ConfirmCancelModal from './ConfirmCancelModal';
import { SCREENS } from '../services/exports/Constants';
import useAppState from '../hooks/global/useAppState';
import useRouter from '../hooks/navigation/useRouter';
import useAppMethods from '../hooks/utility/useAppMethods';
import { ReactElement } from 'react';

const InfoModal = (): ReactElement => {
  const infoModalProps = useAppState()?.infoModalProps;

  const { toggleInfoModal } = useAppMethods();
  const { navigate } = useRouter();

  function _onConfirm(): void {
    if (infoModalProps?.onConfirm) {
      infoModalProps?.onConfirm();

      return toggleInfoModal({ openModal: false });
    }

    navigate({
      web: {
        to: SCREENS.HOME_SCREEN,
      },
    });
    toggleInfoModal({ openModal: false });
  }

  return <ConfirmCancelModal {...infoModalProps} onConfirm={_onConfirm} />;
};

export default InfoModal;
